import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, useHistory } from "react-router-dom";
import { useIdleTimer } from 'react-idle-timer'
import SessionConfirmationPopup from "../Component/CommonPopup/SessionConfirmationPopup"
import { useDispatch, useSelector } from 'react-redux';
import '../App.css';
import Header from '../Container/Header/Header';
import Footer from '../Container/Footer/Footer';
import Login from '../Container/Login/Login';
import Dashboard from '../Container/Dashboard/Dashboard';
import Registration from '../Container/Registration/Registration';
import Fees from '../Container/Fees/Fees';
import Email from '../Component/Email';
import EmailError from '../Component/EmailError';
import Carlist from '../Container/Carlist/Carlist';
import UrCar from '../Container/UrCar/UrCar';
import ContactUs from '../Container/ContactUs/ContactUs';
import MeetTheStaff from '../Container/MeetTheStaff/MeetTheStaff';
import AboutUs from '../Container/Aboutus/Aboutus';
import UrCardetails from '../Container/UrCardetails/UrCardetails';
import Delete from "../Container/UrCardetails/Delete"
import LoadMore from '../Container/UrCar/LoadMore';
import AddViewMore from '../Container/Carlist/RecentlyAddViewMore';
import AllViewMore from '../Container/Carlist/AllViewMore';
import InVoice from '../Container/History/InVoice';
import Inspection from '../Container/History/Inspection';
import LoginActions from '../Container/Login/LoginAction';
import API from '../Services/BaseService';
import Loading from '../Component/Loading/Loading';
// import TitleDue from '../Container/TitleDue/TitleDue';
import TitleDueList from '../Container/TitleDue/TitleDueList';
import InActiveCars from '../Container/InActiveCars/InActiveCars';
import EditDetails from '../Container/UrCardetails/EditDetails';
import RecentlySoldViewMore from '../Container/Carlist/RecentlySoldViewMore';
import SoldCarDetails from '../Container/Carlist/SoldCarDetails';

import ChangePassword from '../Container/ChangePassword/ChangePassword';
import ForgotEmail from '../Container/ForgotPassword/ForgotEmail';
import ForgotPasswordEmail from '../Container/ForgotPassword/ForgotPasswordEmail';
import ForgotPassword from '../Container/ForgotPassword/ForgotPassword';
import InspectorForgotPassword from '../Container/ForgotPassword/InspectorForgotPassword';
import InvalidLink from '../Container/ForgotPassword/InvalidLink';
import ViewMailLog from '../Container/History/BillOfSales/ViewMailLog';
import URpost from '../Container/URpost/URpost';
import History from '../Container/History/History';
import BillOfSale from '../Container/History/BillOfSales/BillOfSale';
import ViewSellercheck from '../Container/History/BillOfSales/ViewSellercheck';
import Chat from '../Container/Chat/Chat';
import ViewMoreHistory from '../Container/History/ViewMoreHistory';
import ViewMoreTitledue from '../Container/TitleDue/ViewMoreTitledue';
import LotFee from '../Container/ManageAccount/LotFee';
import Notification from '../Container/ManageAccount/Notification';
import ManageAccount from '../Container/ManageAccount/ManageAccount';
import Payment from '../Container/ManageAccount/Payment';
import PaymentInfo from '../Container/ManageAccount/PaymentInfo';
import EditPayment from '../Container/ManageAccount/EditPayment';
import Document from '../Container/ManageAccount/Document';
import Seller from '../Container/ManageAccount/Seller/Seller';
import AddUser from '../Container/ManageAccount/Seller/AddUser';
import MyProfile from '../Container/ManageAccount/MyProfile/MyProfile';
import EditMyProfile from '../Container/ManageAccount/MyProfile/EditMyProfile';
import EditDealerInformation from '../Container/ManageAccount/EditDealerInformation';
import EditAddress from '../Container/ManageAccount/Address/EditAddress';
import AddLegalAccount from '../Container/ManageAccount/LegalAccount/AddLegalAccount';
import AddAddress from '../Container/ManageAccount/Address/AddAddress';
import EditLegalAccount from '../Container/ManageAccount/LegalAccount/EditLegalAccount';
// import EditSeller from '../Container/ManageAccount/Seller/EditSeller';
import EditSeller from '../Container/ManageAccount/Seller/SellerView';
import URpostList from '../Container/URpostList/URpostList';
import URpostCarById from '../Container/URpostCar/URpostCar';
import ReRunCarDetails from '../Container/ReRunCar/ReRunCarDetails';
import RerunEditdetails from '../Container/ReRunCar/RerunEditDetails';
import ScrollToTop from "../Component/scrollToTop";
import ls from 'local-storage';
import DashBoardContactus from '../Container/ContactUs/DashBoardContactUs';
import ErrorPage from '../Container/FallBackUI/ErrorPage';
import GatePassPrint from '../Container/History/GatePassPrint';
import SellerCharges from '../Container/SellerCharges/SellerCharges';
import ViewSellerCharges from '../Container/SellerCharges/ViewSellerCharges';
import SellerPayment from '../Container/SellerPayment/SellerPayment';
import '../../src/assets/css/style.css'
import '../../src/assets/css/responsive.css'
import SellerDeleteAccountForm from '../Container/Login/SellerDeleteAccountForm';
import PrivacyPolicyFiles from '../PrivacyPolicyFiles'
// let url = "http://dev-buyer.ur2ndlot.com/cardetail/carID=10026/si=10003"
// let wndUrl = url.split("/");
// ------------------------car details---------------------------------
let wndUrl = window.location.href.split("/");
let lastIndexSIValue = wndUrl[wndUrl.length - 1];
let lastIndexCIValue = wndUrl[wndUrl.length - 2];

let mailViaCarId = lastIndexSIValue === "" || lastIndexSIValue == undefined || lastIndexSIValue === "cardetails" ? "" : lastIndexCIValue.split("carID=")
let mailViasellerDealerId = lastIndexSIValue === "" || lastIndexSIValue == undefined || lastIndexSIValue === "cardetails" ? "" : lastIndexSIValue.split("si=")
console.log("lastIndexSIValue 123", lastIndexSIValue, "wndUrl 123", wndUrl, "lastIndexSIValue ===", lastIndexSIValue.split("si="));

ls.set("mailViaCarId", mailViaCarId === "" ? "" : mailViaCarId.length > 1 ? mailViaCarId[1] : "");
ls.set("mailViasellerDealerId", mailViasellerDealerId === "" ? "" : mailViasellerDealerId.length > 1 ? mailViasellerDealerId[1] : "");
// ------------------------sold car details---------------------------------
let wndSoldUrl = window.location.href.split("/");
let lastIndexSoldCIValue = wndSoldUrl[wndSoldUrl.length - 1];

let mailViaSoldCarId = lastIndexSoldCIValue === "" || lastIndexSoldCIValue == undefined || lastIndexSoldCIValue === "soldcardetails" ? "" : lastIndexSoldCIValue.split("carSID=")
ls.set("mailViaSoldCarId", mailViaSoldCarId === "" ? "" : mailViaSoldCarId.length > 1 ? mailViaSoldCarId[1] : "");
console.log("mailViaSoldCarId 123", mailViaSoldCarId, "lastIndexSoldCIValue", lastIndexSoldCIValue);

function AppRouter() {

  const timeout = 900000;
  // const timeout = 30000;
  const [isSession, setIsSession] = useState(false);// for session popup
  const [remaining, setRemaining] = useState(timeout)
  const history = useHistory();
  const dispatch = useDispatch();
  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false)

  const handleOnIdle = () => {
    if (localStorage.getItem("islogedIn") === "true") {
      setIsSession(true)
    }
  }

  const { getRemainingTime } = useIdleTimer({ timeout, onIdle: handleOnIdle, crossTab: true })

  const PrivateRoute = ({ children, ...rest }) => {
    const isLoggedIn = localStorage.getItem("islogedIn") === "true";
    if (window.location.href.match(/carID/gi)) {
      return (<Route render={({ location }) => {
        return <Redirect to={{ pathname: "/cardetails", state: { from: location, id: mailViaCarId[1], sellerDealerId: mailViasellerDealerId[1] } }} />
      }}>
      </Route>)
    }
    if (window.location.href.match(/carSID/gi)) {
      return (<Route render={({ location }) => {
        return <Redirect to={{ pathname: "/soldcardetails", state: { from: location, id: mailViaSoldCarId[1] } }} />
      }}>
      </Route>)
    }
    else if (window.location.href.match(/carList/)) {
      <Route
        {...rest}
        render={({ location }) => {
          if (isLoggedIn) {
            return children;
          } else {
            return (
              <Redirect to={{ pathname: "/login", state: { from: location } }} />
            );
          }
        }}
      />
    }
    return (<Route {...rest} render={({ location }) => {
      return localStorage.getItem("islogedIn") === "true" ? children : <Redirect to={{ pathname: "/login", state: { from: location } }} />
    }}>
    </Route>)
  }

  useEffect(() => {
    setRemaining(getRemainingTime())
    localStorage.setItem("remainingTime", getRemainingTime())
    const remainingTime = setInterval(() => {
      localStorage.setItem("remainingTime", getRemainingTime())
    }, 1000)
    return () => clearInterval(remainingTime)
  }, [])


  let urlParams = window.location.href;
  console.log(window.location.href, urlParams, "email");
  const isAuctionRoute = urlParams.includes("/carlist");
  const isLoginPage = window.location.pathname === "/login";
  const [isLoading, setIsLoading] = useState(true);
  const emailRegex = /email=([^/]*)/;
  const passwordRegex = /password=([^/]*)/;
  const urlemail = urlParams.match(emailRegex);
  const urlpassword = urlParams.match(passwordRegex);
  const email = urlemail ? urlemail[1] : null;
  const password = urlpassword ? urlpassword[1] : null;
  console.log(email, password, "email1");
  ls.set("loginemail", email)
  ls.set("loginpassword", password)
  console.log("isAuctionRoute:", isAuctionRoute);
  useEffect(() => {

    if (email && password) {
      let request = {
        email: email,
        password: password,
        application_type:"seller"

      };
      API.post("seller/login", request)
        .then((response) => {
          if (response.data.success === true) {
            localStorage.setItem("islogedIn", "true");
            ls.set('userDetails', response.data?.data);
            dispatch(LoginActions.success(response.data.data));
            localStorage.setItem("islogedIn", true)
            localStorage.getItem("loadTime") !== null ? ls.set("loadTime", [localStorage.getItem("loadTime"), ...[Date.now()]]) :
              localStorage.setItem("loadTime", [Date.now()])
            window.location.href = "/carList";
            setIsLoading(false);
          } else {
            setErrors(response.data.error.name)
            setErrorFlag(true)
            setIsLoading(false);
          }
        })
        .catch((error) => {
          if (error.response) {
            setErrors(error.response.data.error)
            setErrorFlag(true)
            setIsLoading(false);
          }
        });
    } else {
      setIsLoading(false);
    }
  }, [email, password, dispatch]);


  return (
    <div>
      <Router>
        {isSession && <SessionConfirmationPopup isToggle={setIsSession} />}
        <Header show={!isLoginPage && !isAuctionRoute} />
        <ScrollToTop />
         {isLoading ? (
          <Loading />
        ) : (
        <Switch>
          <Route exact path="/" component={Dashboard} />
          <Route path="/login" component={Login} />
          <Route path="/registration" component={Registration} />
          <Route path="/fees" component={Fees} />
          <Route path="/email" component={Email} />
          <Route path="/error" component={EmailError} />
          <Route path="/ChangePassword" component={ChangePassword} />
          <Route path="/forgotEmail" component={ForgotEmail} />
          <Route path="/forgotpasswordemail" component={ForgotPasswordEmail} />
          <Route path="/forgotpassword" component={ForgotPassword} />
          <Route path="/inspectorforgotpassword" component={InspectorForgotPassword} />
          <Route path="/InvalidLink" component={InvalidLink} />
          <Route path="/aboutus" component={AboutUs} />
          <Route path="/contactus" component={ContactUs} />
          <Route path="/contactform" component={DashBoardContactus} />
          <Route path="/SellerDeleteAccountForm" component={SellerDeleteAccountForm} />
          <Route path="/privacypolicy" component={PrivacyPolicyFiles} />

          <PrivateRoute>
            <Switch>
              <Route path="/carlist" component={Carlist} />
              <Route path="/urcar" component={UrCar} />
              <Route path="/meetthestaff" component={MeetTheStaff} />
              <Route path="/cardetails" component={UrCardetails} />
              <Route path="/Delete" component={Delete} />
              <Route path="/urcars" component={LoadMore} />
              <Route path="/recentlyaddedcars" component={AddViewMore} />

              <Route path="/allcars" component={AllViewMore} />
              <Route path="/invoice" component={InVoice} />
              <Route path="/inspection" component={Inspection} />

              {/* <Route  path="/titledue" component={TitleDue}/> */}
              <Route path="/titledue" component={TitleDueList} />
              <Route path="/inactivecar" component={InActiveCars} />
              <Route path="/editdetails" component={EditDetails} />
              <Route path="/reRunCarDetails/:id" component={ReRunCarDetails} />
              <Route path="/reRunEditdetails" component={RerunEditdetails} />
              <Route path="/recentlysoldcars" component={RecentlySoldViewMore} />
              <Route path="/soldcardetails" component={SoldCarDetails} />


              <Route path="/urpost" component={URpost} />
              <Route path="/history" component={History} />
              <Route path="/billofsale" component={BillOfSale} />
              <Route path="/chat" component={Chat} />
              <Route path="/urpostlist" component={URpostList} />
              <Route path="/urpostcarbyid" component={URpostCarById} />
              <Route path="/allhistory" component={ViewMoreHistory} />
              {/* <Route Path="/" */}
              <Route path="/alltitledue" component={ViewMoreTitledue} />

              <Route path="/manageaccount" component={ManageAccount} />
              <Route path="/lotfee" component={LotFee} />
              <Route path="/notification" component={Notification} />
              <Route path="/payment" component={Payment} />
              <Route path="/paymentinfo" component={PaymentInfo} />
              <Route path="/editpayment" component={EditPayment} />
              <Route path="/document" component={Document} />
              <Route path="/seller" component={Seller} />
              <Route path="/adduser" component={AddUser} />
              <Route path="/myprofile" component={MyProfile} />
              <Route path="/editmyprofile" component={EditMyProfile} />
              <Route path="/dealerinfoedit" component={EditDealerInformation} />
              <Route path="/addressedit" component={EditAddress} />
              <Route path="/legaledit" component={EditLegalAccount} />
              <Route path="/legaladd" component={AddLegalAccount} />
              <Route path="/addressadd" component={AddAddress} />
              <Route path="/selleredit" component={EditSeller} />
              <Route path="/sellercheck" component={ViewSellercheck} />
              <Route path="/maillogview" component={ViewMailLog} />
              <Route path="/GatePassPrint" component={GatePassPrint} />
              <Route path="/sellercharges" component={SellerCharges} />
              <Route path="/viewsellercharges" component={ViewSellerCharges} />
              <Route path="/sellerpayment" component={SellerPayment} />              
              {!isLoginPage || !isAuctionRoute ?
                <Route path='*' component={ErrorPage} /> : ""}
            </Switch>
          </PrivateRoute>
        </Switch>
         )}
       
          <Footer />
      </Router>
    </div>
  );
}

export default AppRouter;